import React from "react";
import {
  Box,
  Typography,
  Divider,
  Stack,
  Paper,
  useTheme,
  Link,
} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import GitHubIcon from "@mui/icons-material/GitHub";
import LanguageIcon from "@mui/icons-material/Language";
import PublicIcon from "@mui/icons-material/Public";
import UpdateIcon from "@mui/icons-material/Update";
import RouteIcon from "@mui/icons-material/AltRoute";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import VerifiedIcon from "@mui/icons-material/Verified";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

const AboutPage: React.FC = () => {
  breadCrumbsStore.updateBreadCrumbs([{ "About": "/aboutus" }]);

  return (
    <Box sx={{ bgcolor: "#f4f7fb", color: "#333", minHeight: "100vh", p: 4 }}>
      <Paper sx={{ bgcolor: "#fff", p: 4, borderRadius: 3 }} elevation={3}>
        <Typography
          variant="h5"
          fontWeight={700}
          sx={{
            background:
              "linear-gradient(90.92deg, #4AD16E 0.42%, #08B1B6 99.56%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {" "}
          Kudumbashree Loan Management System - Admin Panel
        </Typography>

        <Box mt={3}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Base Data
          </Typography>

          <Stack spacing={1} ml={2}>
            <Stack direction="row" alignItems="center" gap={1}>
              <PublicIcon fontSize="small" />
              <Typography>
                Version: <strong>1.0.0</strong>
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" gap={1}>
              <VerifiedIcon fontSize="small" />
              <Typography>
                Release Name: <strong>KLS-Launch</strong>
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" gap={1}>
              <LanguageIcon fontSize="small" />
              <Typography>
                Developed By:{" "}
                <Link
                  href="https://www.willsoar.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  fontWeight="bold"
                  sx={{
                    background:
                      "linear-gradient(90.92deg, #4AD16E 0.42%, #08B1B6 99.56%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Willsoar Technologies
                </Link>
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" gap={1}>
              <CodeIcon fontSize="small" />
              <Typography>
                Language: <strong>en-IN</strong>
              </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" gap={1}>
              <UpdateIcon fontSize="small" />
              <Typography>
                Last Update: <strong>21/07/2025</strong>
              </Typography>
            </Stack>
          </Stack>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            Components
          </Typography>

          <Box mt={2} ml={2}>
            <Typography variant="body1" fontWeight={600}>
              <CodeIcon fontSize="small" sx={{ mr: 1 }} />
              Technology Stack
            </Typography>
            <Stack spacing={0.5} ml={3}>
              <Stack direction="row" alignItems="center" gap={1}>
                <CodeIcon fontSize="small" />
                <Typography>
                  Frontend: <strong>React + TypeScript + MUI</strong>
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={1}>
                <CodeIcon fontSize="small" />
                <Typography>
                  Backend: <strong>Node.js + Express</strong>
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={1}>
                <StorageIcon fontSize="small" />
                <Typography>
                  Database: <strong>MongoDB</strong>
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={1}>
                <GitHubIcon fontSize="small" />
                <Typography>
                  Version Control: <strong>GitHub</strong>
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <Box mt={3} ml={2}>
            <Typography variant="body1" fontWeight={600}>
              <RouteIcon fontSize="small" sx={{ mr: 1 }} />
              Routes & Sections
            </Typography>
            <Stack spacing={0.5} ml={3}>
              <Stack direction="row" alignItems="center" gap={1}>
                <AccountCircleIcon fontSize="small" />
                <Typography>User Management</Typography>
              </Stack>
              <Typography>District / Block / CDS Setup</Typography>
              <Typography>Loan Application Tracking</Typography>
              <Typography>Loan Sanctioning & Disbursement</Typography>
              <Typography>Repayment Monitoring</Typography>
              <Typography>Monthly Reports & Audit Logs</Typography>
              <Typography>Role-Based Access Control</Typography>
            </Stack>
          </Box>
        </Box>

        <Box mt={4} p={2} sx={{ bgcolor: "#d6f5d6", borderRadius: 2 }}>
          <Typography variant="caption" color="text.secondary">
            © 2025 Kudumbashree Mission. All rights reserved. This software is
            developed to streamline loan processing, improve transparency, and
            empower women's self-help groups (SHGs) across Kerala. Kudumbashree
            is a registered trademark of the Government of Kerala.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default AboutPage;
